import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Form } from 'react-bootstrap';

import PropTypes from 'prop-types';

import Select from 'react-select';

const ObservationTimeDropdown = ({ ObservationTimeChanged }) => {
  const [selectedValue, setSelectedValue] = useState({ value: 12, label: '12:00' });
  const dispatch = useDispatch();

  const selectStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: 'white',
      borderColor: '#adb5bd',
      color: '#494949',
    }),
    container: (styles) => ({ ...styles, width: '100%' }),
    input: (styles) => ({ ...styles }),
    placeholder: (styles) => ({ ...styles, color: '#494949' }),
    dropdownIndicator: (styles) => ({ ...styles, color: '#797979', '&:hover': { color: '#494949' } }),
  };

  const options = [];
  for (var i = 0; i < 24; i++) {
    options.push({ value: i, label: i.toString().padStart(2, '0') + ':00' });
  }

  const handleChange = (event) => {
    setSelectedValue(options.find((x) => x.value === event.value));
    dispatch(ObservationTimeChanged(event.value));
  };

  return (
    <>
      <Form.Label>
        <b>Observation Time</b>
      </Form.Label>
      <Select options={options} styles={selectStyles} value={selectedValue} onChange={handleChange} />
    </>
  );
};

ObservationTimeDropdown.propTypes = {
  ObservationTimeChanged: PropTypes.func,
};

export default ObservationTimeDropdown;
